import React, { Component, PropTypes } from 'react';
import Joi from 'joi';
import composeFormValidation from '../containers/FormValidation';

class FormValidation extends Component {
  constructor(props) {
    super(props);

    this.validatorTypes = {
      username: Joi.string().alphanum().min(3).max(30).required().label('Username'),
      password: Joi.string().regex(/[a-zA-Z0-9]{3,30}/).label('Password'),
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderValidationMessages = this.renderValidationMessages.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.validate();
  }

  getValidatorData() {
    return {
      username: this.refs.username.value,
      password: this.refs.password.value,
    };
  }

  renderValidationMessages(messages) {
    const {
      formatMessage,
    } = this.props.intl;

    return messages.map((message, index) => (
      <div key={index}>{formatMessage(JSON.parse(message))}</div>
    ));
  }

  render() {
    const {
      handleValidation,
      getValidationMessages,
    } = this.props;

    return (
      <form onSubmit={::this.onSubmit}>
        <p>Form Validation Example</p>

        <div>
          <label htmlFor="username">Username</label>
          <input
            ref="username"
            type="text"
            placeholder="Username"
            onBlur={handleValidation('username')}
          />
          <span>{this.renderValidationMessages(getValidationMessages('username'))}</span>
        </div>

        <div>
          <label htmlFor="password">Password</label>
          <input
            ref="password"
            type="password"
            placeholder="Password"
            onBlur={handleValidation('password')}
          />
          <span>{this.renderValidationMessages(getValidationMessages('password'))}</span>
        </div>

        <button onClick={::this.onSubmit}>Submit</button>
      </form>
    );
  }
}

FormValidation.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

export default composeFormValidation(FormValidation);
